import React, { FC } from 'react';
import './_styles.detailsection.css';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';

interface DetailSectionProps {
  title: string;
  value?: string;
  children?: React.ReactNode;
  delay?: number;
}

const DetailSection: FC<DetailSectionProps> = ({
  title,
  value,
  children,
  delay = 0,
}) => {
  return (
    <motion.div
      className='detail-section'
      variants={fadeIn(0.5 + delay)}
      initial='hidden'
      animate='enter'
      exit='exit'
    >
      <p className='detail-title'>{title}</p>
      {value ? <p className='detail-value'>{value}</p> : children}
    </motion.div>
  );
};

export default DetailSection;
